/**
 * onboardingAtoms.js
 * Atomes visuels partages par OnboardingPage et les ecrans du code de
 * recuperation (PF-01 CP4). Extraits d'OnboardingPage pour eviter une
 * duplication de style ou un import circulaire entre la page et ses ecrans.
 *
 * Palette figee CLAUDE.md section 2 : accent solide, jamais en gradient.
 */

import React from 'react';

export const S  = '#00F5A0';
export const G  = '#8892A4';
export const BG = '#0A1628';

export const inputSt = {
  width: '100%', boxSizing: 'border-box',
  padding: '12px 14px',
  background: 'rgba(255,255,255,0.04)',
  border: '1px solid rgba(255,255,255,0.1)',
  borderRadius: 10, color: '#fff', fontSize: 15, outline: 'none',
};

export const BtnPrimary = ({ onClick, disabled, loading, children }) => (
  <button
    onClick={onClick}
    disabled={disabled || loading}
    style={{
      width: '100%', padding: '14px 0',
      background: disabled || loading ? 'rgba(0,245,160,0.25)' : S,
      color: '#0A1628', border: 'none', borderRadius: 10,
      fontWeight: 700, fontSize: 15,
      cursor: disabled || loading ? 'not-allowed' : 'pointer',
      transition: 'background 0.2s',
    }}
  >
    {loading ? 'Enregistrement…' : children}
  </button>
);

export const BtnBack = ({ onClick, children = '← Retour' }) => (
  <button
    type="button"
    onClick={onClick}
    style={{
      background: 'none', border: 'none', color: G, fontSize: 13,
      cursor: 'pointer', display: 'inline-flex', alignItems: 'center',
      gap: 6, padding: '0 0 6px',
    }}
  >
    {children}
  </button>
);

export const MicroText = ({ children }) => (
  <p style={{ margin: '1rem 0 0', fontSize: 12, color: '#445566', textAlign: 'center', lineHeight: 1.5 }}>
    {children}
  </p>
);

export const ErrBox = ({ msg }) => msg ? (
  <div style={{
    background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.25)',
    borderRadius: 8, padding: '10px 14px', color: '#f87171', fontSize: 13,
  }} role="alert">
    {msg}
  </div>
) : null;

/** Carre 52 px accent, en-tete visuel commun aux ecrans sensibles. */
export const IconFrame = ({ children }) => (
  <div style={{
    width: 52, height: 52, borderRadius: 12,
    background: 'rgba(0,245,160,0.08)',
    border: '1px solid rgba(0,245,160,0.25)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    color: S, marginBottom: '1.25rem',
  }}>
    {children}
  </div>
);

/** Icone cle — ecrans du code de recuperation. */
export const IconKey = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"/>
  </svg>
);
